module.exports = __webpack_public_path__ + "static/pic10-bbdcfe579cf8cc377d1357b9ab8fc744.png";